// extracted by mini-css-extract-plugin
export default {"credits":"credits--AHa5N","logo":"logo--fImVB","text":"text--dzRgv"};